import React, { useState } from "react";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import { userReg, userRegConfirm } from "./auth.api";
import OTPInput from "otp-input-react";
import "./login.css";
import "../otp/otp.css";
import "./signup.css";

export default function Login(props) {
  const [loginParams, setLoginParams] = useState(() => {
    const savedPhone = sessionStorage.getItem("registration_phone");
    return savedPhone ? { mobile_number: savedPhone } : {};
  });
  const [otpStep, setOtpStep] = useState(() => {
    return sessionStorage.getItem("registration_step") || "mobile";
  });
  const [submit, setSubmit] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [newuser, setnewuser] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [error, setError] = useState(false);
  const [OTP, setOTP] = useState("");

  const verifyUser = (e) => {
    e.preventDefault();
    setIsActive(true);
    setSubmit(true);
    if (!error && loginParams.mobile_number) {
      userReg(loginParams)
        .then((res) => {
          if (res.new_user) {
            setnewuser(false);
            props.setPhone(loginParams.mobile_number);
            sessionStorage.setItem("registration_phone", loginParams.mobile_number);
            sessionStorage.setItem("registration_step", "otp");

            setSnackMessage(res.message || "OTP has been sent to your phone");
            setIsSnackError(false);
            setIsActive(false);
            setSnackOpen(true);
            setSubmit(false);
          } else {
            setnewuser(true);
            setSnackMessage("This mobile number is already registered");
            setIsSnackError(true);
            setSnackOpen(true);
            setIsActive(false);
            setSubmit(false);
          }
        })
        .catch((err) => {
          setSubmit(false);
          setSnackMessage(err.response?.data?.message || "Registration failed");
          setIsSnackError(true);
          setSnackOpen(true);
          setIsActive(false);
        });
    } else {
      setSubmit(false);
      setSnackMessage("Enter a valid Phone number");
      setIsSnackError(true);
      setSnackOpen(true);
      setIsActive(false);
    }
  };

  const handleOtpVerify = (e) => {
    e.preventDefault();
    setSubmit(true);
    setIsActive(true);

    const activePhone = props.phone || loginParams.mobile_number || sessionStorage.getItem("registration_phone");

    let data = {
      mobile_number: activePhone,
      otp_value: OTP,
    };

    userRegConfirm(data)
      .then((res) => {
        setSubmit(false);
        setIsActive(false);
        setSnackMessage(res.message || "OTP verified successfully");
        setIsSnackError(false);
        setSnackOpen(true);
      })
      .catch((err) => {
        setSubmit(false);
        setIsActive(false);
        setSnackMessage(err.response?.data?.message || "Verification failed");
        setIsSnackError(true);
        setSnackOpen(true);
      });
  };

  const resendOtp = (e) => {
    e.preventDefault();
    setSubmit(true);
    setIsActive(true);
    const activePhone = props.phone || loginParams.mobile_number || sessionStorage.getItem("registration_phone");
    let loginParam = { mobile_number: activePhone };
    userReg(loginParam)
      .then((res) => {
        setSnackMessage(res.message || "OTP has been sent to your phone");
        setIsSnackError(false);
        setSnackOpen(true);
        setSubmit(false);
        setIsActive(false);
      })
      .catch((err) => {
        setSubmit(false);
        setIsActive(false);
        setSnackMessage(err.response?.data?.message || "Failed to resend OTP");
        setIsSnackError(true);
        setSnackOpen(true);
      });
  };

  const handleBackToMobile = () => {
    setOtpStep("mobile");
    setOTP("");
    sessionStorage.removeItem("registration_step");
    sessionStorage.removeItem("registration_phone");
  };

  const handleChange = (e) => {
    var ticket = e.target.value;
    const sequentialPattern = /(012345|123456|234567|345678|456789|987654|876543|765432|654321|543210|999999|111111111|2222222|33333333|44444444|55555555|6666666666|7777777777|8888888)/;
    const phoneNumberRegex = /^(?!(\d)\1{9})[6-9]\d{9}$/;
    var reg = new RegExp("^[0-9]*$");

    if (e.target.validity.patternMismatch) {
      e.target.setCustomValidity("Please enter valid 10 digit number");
    } else {
      e.target.setCustomValidity("");
    }

    if (reg.test(ticket) && phoneNumberRegex.test(ticket) && !sequentialPattern.test(ticket)) {
      setLoginParams({ [e.target.name]: ticket });
      setError(false);
    } else {
      setError(true);
      setLoginParams({ [e.target.name]: ticket });
    }
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      if (otpStep === "mobile") {
        setOtpStep("otp");
        sessionStorage.setItem("registration_step", "otp");
      } else if (otpStep === "otp") {
        sessionStorage.removeItem("registration_phone");
        sessionStorage.removeItem("registration_step");
        props.valid();
        const activelocation = sessionStorage.getItem("active_path") || "/";
        setTimeout(() => {
          props.history.push(activelocation);
        }, 100);
      }
    } else if (flag && newuser) {
      localStorage.clear();
      sessionStorage.removeItem("registration_phone");
      sessionStorage.removeItem("registration_step");
      props.history.push("/login");
    }
  };

  return (
    <div className="login-page-wrapper">
      <Loader open={isActive} />

      <div className="login-unified-container">
        {/* Left Column: Branding & Portal Information */}
        <div className="login-info-column">
          <div className="login-info-brand">
            <img src="/latest-logo.png" alt="Kerala Government" className="info-brand-logo" />
            <div className="info-brand-divider"></div>
            <h1 className="info-brand-title">Kerala Spacepark</h1>
          </div>

          <div className="login-info-content">
            <h2 className="info-welcome-title">Join KSPACE (Kerala Spacepark)</h2>
            <p className="info-welcome-text">
              Register to gain access to KSPACE features, resources, opportunities, and services designed for companies, institutions, and professionals.
            </p>
            <p className="info-welcome-text" style={{ fontSize: "13px", color: "#cbd5e1", opacity: 0.9, fontStyle: "italic", marginBottom: "20px", borderLeft: "3px solid rgba(255,255,255,0.4)", paddingLeft: "10px" }}>
              Please provide your primary mobile number to begin the two-factor registration process. An OTP will be sent to verify your identity.
            </p>

            <div className="info-features-list">
              <div className="info-feature-item">
                <div className="info-feature-icon">
                  <i className="fa fa-user-plus"></i>
                </div>
                <div className="info-feature-text">
                  <strong>Simple Registration</strong>
                  <span>Verify your mobile number with a one-time passcode to set up your account.</span>
                </div>
              </div>

              <div className="info-feature-item">
                <div className="info-feature-icon">
                  <i className="fa fa-shield-alt"></i>
                </div>
                <div className="info-feature-text">
                  <strong>Secure Access</strong>
                  <span>Your account is protected by verified mobile OTP verification for reliable authorization.</span>
                </div>
              </div>
            </div>

            <div className="mt-4" style={{ fontWeight: "500", fontSize: "14px", color: "rgba(255,255,255,0.8)" }}>
              Thank you.
            </div>
          </div>

          <div className="login-info-footer">
            <span>© {new Date().getFullYear()} Kerala Spacepark (KSPACE). All rights reserved.</span>
          </div>
        </div>

        {/* Right Column: Dynamic Form */}
        <div className="login-form-column">
          <div className="login-card-container">
            <div className="login-card-body">
              {otpStep === "mobile" ? (
                <form onSubmit={verifyUser} className="login-form-anim">
                  <div className="form-avatar-header">
                    <div className="avatar-circle">
                      <i className="fa fa-user-plus"></i>
                    </div>
                    <h3 className="form-title">Create Account</h3>
                    <p className="form-subtitle">Enter your mobile number to register</p>
                  </div>

                  <div className="form-group-custom">
                    <label className="form-input-label">Mobile Number</label>
                    <div className="mobile-input-group">
                      <span className="mobile-country-code">+91</span>
                      <input
                        type="tel"
                        className={`form-input-field ${error ? "error" : ""}`}
                        name="mobile_number"
                        maxLength="10"
                        minLength="10"
                        pattern="[0-9]{10}"
                        placeholder="Mobile number"
                        required
                        value={loginParams.mobile_number ?? ""}
                        onChange={handleChange}
                      />
                    </div>
                    {error && (
                      <span className="form-error-msg">Please enter a valid 10-digit mobile number</span>
                    )}
                  </div>

                  <button
                    className="login-submit-button"
                    type="submit"
                    disabled={submit}
                  >
                    <span>Verify Mobile</span>
                    <i className="fa fa-arrow-right"></i>
                  </button>
                </form>
              ) : (
                <form onSubmit={handleOtpVerify} className="login-form-anim">
                  <div className="form-avatar-header">
                    <div className="avatar-circle">
                      <i className="fa fa-shield-alt"></i>
                    </div>
                    <h3 className="form-title">Enter Verification Code</h3>
                    <p className="form-subtitle">We have sent a 6-digit OTP to +91 {loginParams.mobile_number || sessionStorage.getItem("registration_phone")}</p>
                  </div>

                  <div className="form-group-custom d-flex flex-column align-items-center justify-content-center">
                    <OTPInput
                      value={OTP}
                      onChange={setOTP}
                      autoFocus
                      OTPLength={6}
                      otpType="number"
                      disabled={false}
                      secure={true}
                      inputClassName="otp-field-input"
                      className="otp-input-react-container"
                    />
                  </div>

                  <button
                    className="login-submit-button"
                    type="submit"
                    disabled={submit || OTP.length < 6}
                  >
                    <span>Verify OTP</span>
                    <i className="fa fa-check-circle"></i>
                  </button>

                  <div className="d-flex justify-content-between mt-4">
                    <span className="form-link-back" onClick={handleBackToMobile}>
                      <i className="fa fa-arrow-left"></i> Change Number
                    </span>
                    <span className="form-link-resend" onClick={resendOtp}>
                      Resend OTP <i className="fa fa-sync-alt"></i>
                    </span>
                  </div>
                </form>
              )}
            </div>

            <div className="text-center mt-2">
              <span className="back-to-home-link" onClick={() => props.history.push("/login")}>
                <i className="fa fa-sign-in-alt"></i> Already registered? Log In
              </span>
            </div>
          </div>
        </div>
      </div>

      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
    </div>
  );
}
